"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dbToPrompt = dbToPrompt;
exports.entityToPrompt = entityToPrompt;
exports.cleanSqlAnswer = cleanSqlAnswer;
const utils_1 = require("@azimutt/utils");
const databaseUtils_1 = require("../databaseUtils");
function dbToPrompt(db) {
    // TODO: depending on selected model, decide if db can be fully integrated or should be compressed (no types, filter tables...) or have additional data (sample values, stats...)
    const relationsBySrc = (0, utils_1.groupBy)(db.relations || [], r => (0, databaseUtils_1.entityRefToId)(r.src));
    const entities = (db.entities || []).map(e => entityToPrompt(e, relationsBySrc[(0, databaseUtils_1.entityToId)(e)] || []));
    return `\`\`\`
${entities.join('\n')}
\`\`\``;
}
function entityToPrompt(e, rels) {
    const [compositeRelations, simpleRelations] = (0, utils_1.partition)(rels, r => r.src.attrs.length > 1);
    const simpleRelationsByAttr = (0, utils_1.groupBy)(simpleRelations, r => (0, databaseUtils_1.attributePathToId)(r.src.attrs[0]));
    const polymorphicRelations = Object.values(simpleRelationsByAttr).filter(rs => rs.length > 1).flatMap(rs => rs);
    const attrs = (e.attrs || []).map(a => attributeToPrompt(a, simpleRelationsByAttr[a.name] || []));
    const otherRels = compositeRelations.concat(polymorphicRelations).map(entityForeignKey);
    return `CREATE TABLE ${(0, databaseUtils_1.entityToId)(e)} (${attrs.concat(otherRels).join(', ')});`;
}
function attributeToPrompt(a, rels) {
    return `${a.name} ${a.type}${rels.length === 1 ? ` REFERENCES ${(0, databaseUtils_1.entityRefToId)(rels[0].ref)}(${(0, databaseUtils_1.attributePathToId)(rels[0].ref.attrs[0])})` : ''}`;
}
function entityForeignKey(r) {
    return `FOREIGN KEY (${r.src.attrs.map(databaseUtils_1.attributePathToId).join(', ')}) REFERENCES ${(0, databaseUtils_1.entityRefToId)(r.ref)}(${r.ref.attrs.map(databaseUtils_1.attributePathToId).join(', ')})`;
}
function cleanSqlAnswer(answer) {
    const mdCode = answer.trim().match(/^(?:```)?(?:sql)?\n?(.+?)\n?(?:```)?$/s);
    if (mdCode)
        return mdCode[1];
    return answer.trim();
}
//# sourceMappingURL=llmUtils.js.map